import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const names = ['María', 'Luciana', 'Valentina', 'Camila', 'Sofía', 'Martina', 'Florencia', 'Agustina', 'Micaela', 'Julieta'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setNotification({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setIsFadingOut(false);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsFadingOut(true);
        setTimeout(() => {
          setIsVisible(false);
        }, 500); // Wait for fade out animation
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showPopup();
      // Setup recurring interval (between 8 and 12 seconds)
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 4000) + 8000);
      return () => clearInterval(interval);
    }, 3000);
    return () => clearTimeout(initialTimer);
  }, []);
  if (!isVisible) return null;
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-xl border border-brand-roseLight p-4 flex items-start space-x-3 ${isFadingOut ? 'animate-fade-out' : 'animate-slide-up'}`} data-id="element-101">
      <div className="flex-shrink-0 mt-0.5" data-id="element-102">
        <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-103" />
      </div>
      <div data-id="element-104">
        <p className="text-sm font-medium text-gray-900" data-id="element-105">
          {notification.name} de {notification.city}
        </p>
        <p className="text-xs text-gray-500 mt-1" data-id="element-106">
          Compró este producto hace {notification.time}{' '}
          {notification.time === 1 ? 'minuto' : 'minutos'}
        </p>
      </div>
    </div>;
}